// app/composables/device/useTouchDevice.ts

/**
 * Composable to detect if the current device is a touch device
 *
 * Uses multiple detection methods for better accuracy:
 * - Media query (pointer: coarse) for devices with imprecise pointing (touch)
 * - Touch events support detection
 *
 * @returns {Ref<boolean>} isTouchDevice - Reactive reference that is true if device is touch-enabled
 *
 * @example
 * const { isTouchDevice } = useTouchDevice()
 * if (isTouchDevice.value) {
 *   // Hide navigation arrows on touch devices
 * }
 */
export function useTouchDevice() {
  const isTouchDevice = ref<boolean>(false);

  onMounted(() => {
    // Method 1: Media query for coarse pointer (most reliable for modern devices)
    const hasCoarsePointer = window.matchMedia("(pointer: coarse)").matches;

    // Method 2: Check for touch events support
    const hasTouchEvents =
      "ontouchstart" in window || navigator.maxTouchPoints > 0 || (navigator as any).msMaxTouchPoints > 0;

    // Device is considered touch if it has either coarse pointer OR touch events
    isTouchDevice.value = hasCoarsePointer || hasTouchEvents;
  });

  return {
    isTouchDevice,
  };
}
